import $ from "jquery";
import "datatables.net";
import "datatables.net-fixedcolumns-dt";

class DataTable {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        $(document).ready(function() {
            if (!$.fn.DataTable.isDataTable(this.elem)) {
                $(self.elem).DataTable({
                    lengthChange: false,
                    searching: false,
                    ordering: true,
                    bSort: false,
                    paging: false,
                    bInfo: false,
                    // scrollX: true,
                    // scrollCollapse: true,
                    // fixedColumns: true,
                    autoWidth: true,
                    order: [[ parseInt(self.elem.getAttribute('data-colOrder')), self.elem.getAttribute('data-colSort') ]],

                    columnDefs: [
                        {
                            targets: 1,
                            width: "150px"
                        }
                    ],

                    fixedColumns: {
                        leftColumns: 0,
                        rightColumns: 1,
                    }
                });
            };
        });
    }
}

export default DataTable;
